import classNames from 'classnames';
import { useEffect } from 'react';

import { disableBodyScroll, enableBodyScroll } from 'shared/util/bodyScroll';
import type { Filters } from '@/domain';
import { Filter } from '../filters/Filter';

type ResultFilterMapProps = {
    filtersOpen: boolean;
    filters: Filters;
    filterResults: (filters: Filters) => void;
    filterData: Record<string, unknown>;
};

export const ResultFilterMap = ({ filterData, filterResults, filters, filtersOpen }: ResultFilterMapProps) => {
    useEffect(() => {
        if (filtersOpen) {
            disableBodyScroll();
        } else {
            enableBodyScroll();
        }
    });

    return (
        <div className={classNames('filters-overlay-map map-view', { active: filtersOpen })}>
            <Filter onFilterChanged={filterResults} filterData={filterData} filters={filters} />
        </div>
    );
};
